import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { MemberEmailLogResponse } from '../interface/member-email-log-response.interface';
import { MemberEmailLogSearchRequest } from '../interface/member-email-log-search-request.interface';
import { MemberEmailLog } from '../interface/member-email-log.interface';
import { MemberEmailResendResponse } from '../interface/member-email-ressend-response.inteface';
import { MemberEmailView } from '../interface/member-email-view.interface';

@Injectable()
export class EmailLogService {

    constructor(
        private _http: Http
    ) { }

    /**
     * @description getting Member Email logs
     * @date 2019-07-11
     * @param {string} fboProfileId
     * @returns {Observable<MemberEmailLog[]>}
     * @memberof EmailLogService
     */
    getMemberEmailLogs(memberId: number, memberEmailLogSearchRequest: MemberEmailLogSearchRequest,
        pageSize: number, pageNumber: number): Observable<MemberEmailLogResponse> {
        let emailLogUrl = decodeURIComponent(encodeURIComponent(ApiUrlConstants.communicationApiUrl
            + 'email-logs/' + memberId + '?countryCode=' + memberEmailLogSearchRequest.countryCode
            + '&startDate=' + memberEmailLogSearchRequest.startDate + '&endDate=' + memberEmailLogSearchRequest.endDate
            + '&pageSize=' + pageSize + '&pageNumber=' + pageNumber + '&timeZoneOffset=' + encodeURIComponent(memberEmailLogSearchRequest.timeZoneOffset)));
        if (memberEmailLogSearchRequest.subject) {
            emailLogUrl = emailLogUrl + '&subject=' + memberEmailLogSearchRequest.subject;
        }
        if (memberEmailLogSearchRequest.sentTo) {
            emailLogUrl = emailLogUrl + '&sentTo=' + encodeURIComponent(memberEmailLogSearchRequest.sentTo);
        }
        if(memberEmailLogSearchRequest.distributorId){
            emailLogUrl = emailLogUrl + '&distributorId=' + memberEmailLogSearchRequest.distributorId;
        }
        if (memberEmailLogSearchRequest.sortOrder && memberEmailLogSearchRequest.sortBy) {
            emailLogUrl = emailLogUrl + '&sortOrder=' + memberEmailLogSearchRequest.sortOrder
                + '&sortBy=' + memberEmailLogSearchRequest.sortBy;
        }

        return this._http.get(emailLogUrl)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @description getmemberEmailDetails
     * @date 2019-07-12
     * @param {number} emailMessageId
     * @param {string} sendTo
     * @returns {Observable<MemberEmailSearch>}
     * @memberof EmailLogService
     */
    getMemberEmailDetails(emailMessageId: number, mailStatusId: number): Observable<MemberEmailView> {
        const emailViewUrl = decodeURIComponent(encodeURIComponent(ApiUrlConstants.communicationApiUrl
            + 'email-details/' + emailMessageId + '/mailStatusId/' + mailStatusId));
        return this._http.get(emailViewUrl)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }
    /**
     * @description memberResendMail
     * @date 2019-07-16
     * @param {number} emailMessageId
     * @returns {Observable<MemberEmailResendResponse>}
     * @memberof EmailLogService
     */
    reSendMemberMail(emailMessageId: number): Observable<MemberEmailResendResponse> {
        const emailResendUrl = decodeURIComponent(encodeURIComponent(ApiUrlConstants.communicationApiUrl
            + 'send-email/' + emailMessageId));
        return this._http.post(emailResendUrl, JSON.stringify({}))
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
   * To handle the obervable error response
   * @param  {Response|any} error
   */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/services/email-log.service.ts